package com.evoapps.evoshift.ui.finance

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ExperimentalLayoutApi
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.LazyRow
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.lazy.rememberLazyListState
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.automirrored.filled.CallSplit
import androidx.compose.material.icons.automirrored.filled.KeyboardArrowLeft
import androidx.compose.material.icons.automirrored.filled.KeyboardArrowRight
import androidx.compose.material.icons.automirrored.filled.Undo
import androidx.compose.material.icons.filled.CheckCircle
import androidx.compose.material.icons.filled.DoneAll
import androidx.compose.material.icons.filled.Edit
import androidx.compose.material.icons.filled.EventNote
import androidx.compose.material.icons.filled.HowToReg
import androidx.compose.material.icons.filled.Lock
import androidx.compose.material.icons.filled.MoreHoriz
import androidx.compose.material.icons.filled.Schedule
import androidx.compose.material.icons.filled.Timer
import androidx.compose.material3.Button
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.DropdownMenu
import androidx.compose.material3.DropdownMenuItem
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedButton
import androidx.compose.material3.Scaffold
import androidx.compose.material3.SnackbarHost
import androidx.compose.material3.SnackbarHostState
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.saveable.rememberSaveable
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.platform.testTag
import androidx.compose.ui.semantics.contentDescription
import androidx.compose.ui.semantics.semantics
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import com.evoapps.evoshift.widgets.IconButtonWithTooltip
import com.evoapps.evoshift.domain.model.TimeRange
import com.evoapps.evoshift.domain.model.WorkHoursDaySummary
import com.evoapps.evoshift.domain.model.WorkHoursRow
import com.evoapps.evoshift.domain.model.WorkHoursStatus
import com.evoapps.evoshift.domain.util.plannedTimeRange
import com.evoapps.evoshift.ui.Cream
import com.evoapps.evoshift.ui.DeepNavy
import com.evoapps.evoshift.ui.LightGold
import com.evoapps.evoshift.ui.adaptive.ContentMaxWidth
import com.evoapps.evoshift.ui.adaptive.LocalWindowWidthClass
import com.evoapps.evoshift.ui.adaptive.contentWidth
import com.evoapps.evoshift.ui.adaptive.handCursor
import com.evoapps.evoshift.ui.adaptive.showsDetailPane
import com.evoapps.evoshift.ui.roster.ActualWorkDialog
import com.evoapps.evoshift.ui.roster.ActualWorkLines
import com.evoapps.evoshift.ui.roster.SplitShiftDialog
import com.evoapps.evoshift.ui.user.clockFlagLabel
import com.evoapps.evoshift.domain.model.workerId
import com.evoapps.evoshift.ui.util.asString
import com.evoapps.evoshift.ui.util.dayAndDate
import com.evoapps.evoshift.ui.util.dayShort
import com.evoapps.evoshift.ui.util.personName
import com.evoapps.evoshift.viewmodels.WorkHoursUiState
import com.evoapps.evoshift.viewmodels.WorkHoursViewModel
import com.evoapps.evoshift.widgets.DialogAction
import com.evoapps.evoshift.widgets.ErrorState
import com.evoapps.evoshift.widgets.EvoDialog
import com.evoapps.evoshift.widgets.EvoTimeField
import com.evoapps.evoshift.widgets.EvoTopBar
import com.evoapps.evoshift.widgets.SkeletonCard
import com.evoapps.evoshift.widgets.parseClockTime
import evoshift.composeapp.generated.resources.Res
import evoshift.composeapp.generated.resources.actual_work_action
import evoshift.composeapp.generated.resources.actual_work_end
import evoshift.composeapp.generated.resources.actual_work_start
import evoshift.composeapp.generated.resources.clock_review_edit_invalid
import evoshift.composeapp.generated.resources.daily_hours_line
import evoshift.composeapp.generated.resources.daily_hours_line_confirmed
import evoshift.composeapp.generated.resources.daily_hours_line_none
import evoshift.composeapp.generated.resources.daily_hours_line_plain
import evoshift.composeapp.generated.resources.daily_hours_shifts
import evoshift.composeapp.generated.resources.work_hours_open
import evoshift.composeapp.generated.resources.save
import evoshift.composeapp.generated.resources.split_action
import evoshift.composeapp.generated.resources.split_undo
import evoshift.composeapp.generated.resources.work_hours_actual
import evoshift.composeapp.generated.resources.work_hours_as_clocked
import evoshift.composeapp.generated.resources.work_hours_as_planned
import evoshift.composeapp.generated.resources.work_hours_clocked
import evoshift.composeapp.generated.resources.work_hours_confirm_day
import evoshift.composeapp.generated.resources.work_hours_confirm_day_hint
import evoshift.composeapp.generated.resources.work_hours_confirm_reported
import evoshift.composeapp.generated.resources.work_hours_day_confirmed
import evoshift.composeapp.generated.resources.work_hours_day_no_shifts
import evoshift.composeapp.generated.resources.work_hours_day_not_over
import evoshift.composeapp.generated.resources.work_hours_day_to_confirm
import evoshift.composeapp.generated.resources.work_hours_days
import evoshift.composeapp.generated.resources.work_hours_change
import evoshift.composeapp.generated.resources.work_hours_edit
import evoshift.composeapp.generated.resources.work_hours_edit_planned
import evoshift.composeapp.generated.resources.work_hours_edit_title
import evoshift.composeapp.generated.resources.work_hours_locked
import evoshift.composeapp.generated.resources.work_hours_next_day
import evoshift.composeapp.generated.resources.work_hours_not_clocked
import evoshift.composeapp.generated.resources.work_hours_note
import evoshift.composeapp.generated.resources.work_hours_plan
import evoshift.composeapp.generated.resources.work_hours_previous_day
import evoshift.composeapp.generated.resources.work_hours_reported
import evoshift.composeapp.generated.resources.work_hours_status_confirmed
import evoshift.composeapp.generated.resources.work_hours_status_not_worked
import evoshift.composeapp.generated.resources.work_hours_status_not_yet
import evoshift.composeapp.generated.resources.work_hours_status_reported
import evoshift.composeapp.generated.resources.work_hours_status_to_confirm
import evoshift.composeapp.generated.resources.work_hours_status_to_decide
import evoshift.composeapp.generated.resources.work_hours_title
import evoshift.composeapp.generated.resources.work_hours_who_worked
import kotlinx.datetime.LocalDate
import org.jetbrains.compose.resources.stringResource

/** Test tags: a shift's row and its actions (followed by the shift's id), a day in the pager (followed by the ISO date). */
const val WORK_HOURS_ROW_TAG = "work_hours_row_"
const val WORK_HOURS_AS_PLANNED_TAG = "work_hours_as_planned_"
const val WORK_HOURS_AS_CLOCKED_TAG = "work_hours_as_clocked_"
const val WORK_HOURS_EDIT_TAG = "work_hours_edit_"
const val WORK_HOURS_CHANGE_TAG = "work_hours_change_"
const val WORK_HOURS_MORE_TAG = "work_hours_more_"
const val WORK_HOURS_STATUS_TAG = "work_hours_status_"
const val WORK_HOURS_DAY_TAG = "work_hours_day_"
const val WORK_HOURS_DAY_STATUS_TAG = "work_hours_day_status"
const val WORK_HOURS_CONFIRM_DAY_TAG = "work_hours_confirm_day"
const val WORK_HOURS_EDIT_START_TAG = "work_hours_edit_start"
const val WORK_HOURS_EDIT_END_TAG = "work_hours_edit_end"
const val WORK_HOURS_PLACEHOLDER_TAG = "work_hours_placeholder"

private val ToConfirmColor = Color(0xFFB45309)
private val ConfirmedColor = Color(0xFF2E7D32)
/** Confirmed, on the navy day card. */
private val ConfirmedOnNavy = Color(0xFF81C784)

/**
 * SH-257: "Godziny pracy": day by day (a pager on phones, the month's days beside the day on wide
 * windows), each shift's person, planned, clocked (or entered by the employee) and actual times
 * with the SH-134 flags, and one tap to confirm them as planned or as clocked, to type them, or
 * to say who actually worked (the SH-236 dialogs); "Potwierdź dzień" confirms the rest. [clockReview]
 * is the day's SH-134 "Do sprawdzenia" list (unplanned clock-ins are decided there).
 */
@Composable
fun WorkHoursScreen(
    viewModel: WorkHoursViewModel,
    onNavigateBack: () -> Unit,
    clockReview: @Composable (date: String) -> Unit = {}
) {
    val state by viewModel.uiState.collectAsState()
    val snackbar = remember { SnackbarHostState() }
    val note = (state.error ?: state.message)?.asString()
    LaunchedEffect(note) {
        if (note != null) {
            snackbar.showSnackbar(note)
            viewModel.messageShown()
        }
    }
    Scaffold(
        containerColor = Cream,
        snackbarHost = { SnackbarHost(snackbar) },
        topBar = { EvoTopBar(title = stringResource(Res.string.work_hours_title), onBack = onNavigateBack, showWorkplace = true) }
    ) { padding ->
        val loadError = state.loadError
        val date = state.selectedDate
        when {
            loadError != null && state.shifts.isEmpty() -> ErrorState(loadError, onRetry = viewModel::retry, modifier = Modifier.padding(padding))
            // SH-247: the day's rows until the month is read.
            state.isLoading || date == null || state.today == null -> WorkHoursPlaceholder(Modifier.padding(padding))
            LocalWindowWidthClass.current.showsDetailPane -> Row(Modifier.fillMaxSize().padding(padding)) {
                DayList(state, date, onSelect = viewModel::selectDay, modifier = Modifier.width(300.dp).fillMaxHeight())
                Column(Modifier.weight(1f).fillMaxHeight().verticalScroll(rememberScrollState()).padding(16.dp)) {
                    DayHeader(state, date, viewModel)
                    Spacer(Modifier.size(12.dp))
                    DayContent(state, date, viewModel, clockReview)
                }
            }
            else -> Column(Modifier.fillMaxSize().padding(padding)) {
                DayStrip(state, date, onSelect = viewModel::selectDay)
                // SH-161: one column of at most the reading width on a tablet in portrait.
                Column(Modifier.weight(1f).fillMaxWidth().verticalScroll(rememberScrollState()).contentWidth(ContentMaxWidth).padding(horizontal = 16.dp, vertical = 8.dp)) {
                    DayHeader(state, date, viewModel)
                    Spacer(Modifier.size(12.dp))
                    DayContent(state, date, viewModel, clockReview)
                }
            }
        }
    }
}

@Composable
private fun WorkHoursPlaceholder(modifier: Modifier = Modifier) {
    Column(
        modifier.fillMaxSize().padding(16.dp).testTag(WORK_HOURS_PLACEHOLDER_TAG),
        verticalArrangement = Arrangement.spacedBy(12.dp)
    ) {
        SkeletonCard(lines = 1)
        repeat(3) { SkeletonCard(lines = 3) }
    }
}

/** The day's title with the previous and next day, and its status ("3 do potwierdzenia" / "Potwierdzony"). */
@Composable
private fun DayHeader(state: WorkHoursUiState, date: String, viewModel: WorkHoursViewModel) {
    Row(verticalAlignment = Alignment.CenterVertically, modifier = Modifier.fillMaxWidth()) {
        IconButtonWithTooltip(onClick = viewModel::previousDay, modifier = Modifier.handCursor(), tooltip = stringResource(Res.string.work_hours_previous_day)) {
            Icon(Icons.AutoMirrored.Filled.KeyboardArrowLeft, contentDescription = stringResource(Res.string.work_hours_previous_day), tint = DeepNavy)
        }
        Column(Modifier.weight(1f), horizontalAlignment = Alignment.CenterHorizontally) {
            Text(
                dayAndDate(LocalDate.parse(date)),
                style = MaterialTheme.typography.titleMedium, fontWeight = FontWeight.Bold, color = DeepNavy,
                maxLines = 1, overflow = TextOverflow.Ellipsis
            )
            state.summary(date)?.let { DayStatus(it, state.askingWhoWorked(date).size, Modifier.testTag(WORK_HOURS_DAY_STATUS_TAG)) }
        }
        IconButtonWithTooltip(onClick = viewModel::nextDay, modifier = Modifier.handCursor(), tooltip = stringResource(Res.string.work_hours_next_day)) {
            Icon(Icons.AutoMirrored.Filled.KeyboardArrowRight, contentDescription = stringResource(Res.string.work_hours_next_day), tint = DeepNavy)
        }
    }
}

@Composable
private fun DayStatus(summary: WorkHoursDaySummary, askingWhoWorked: Int, modifier: Modifier = Modifier) {
    val (text, color) = when {
        // SH-262: open shifts still asking who worked them need doing too, the day isn't empty.
        summary.shifts == 0 && askingWhoWorked > 0 -> stringResource(Res.string.work_hours_day_to_confirm, askingWhoWorked) to ToConfirmColor
        summary.shifts == 0 -> stringResource(Res.string.work_hours_day_no_shifts) to DeepNavy.copy(alpha = 0.6f)
        summary.toConfirm > 0 -> stringResource(Res.string.work_hours_day_to_confirm, summary.toConfirm) to ToConfirmColor
        summary.confirmed -> stringResource(Res.string.work_hours_day_confirmed) to ConfirmedColor
        else -> stringResource(Res.string.work_hours_day_not_over) to DeepNavy.copy(alpha = 0.6f)
    }
    Text(text, style = MaterialTheme.typography.bodyMedium, fontWeight = FontWeight.SemiBold, color = color, modifier = modifier)
}

/** The day's marker in the pager and the list: to confirm (amber), confirmed (green), else none. */
@Composable
private fun DayMarker(summary: WorkHoursDaySummary?) {
    val color = when {
        summary == null || summary.shifts == 0 -> Color.Transparent
        summary.toConfirm > 0 -> ToConfirmColor
        summary.confirmed -> ConfirmedColor
        else -> Color.Transparent
    }
    Box(Modifier.size(8.dp).background(color, CircleShape))
}

/** Phones: the month's days in a strip, the chosen one in navy, each with its marker. */
@Composable
private fun DayStrip(state: WorkHoursUiState, selected: String, onSelect: (String) -> Unit) {
    val days = state.days
    val listState = rememberLazyListState()
    LaunchedEffect(selected, days.size) {
        val index = days.indexOf(selected)
        if (index >= 0) listState.animateScrollToItem((index - 2).coerceAtLeast(0))
    }
    LazyRow(
        state = listState,
        contentPadding = PaddingValues(horizontal = 12.dp, vertical = 8.dp),
        horizontalArrangement = Arrangement.spacedBy(6.dp)
    ) {
        items(days, key = { it }) { day ->
            val date = LocalDate.parse(day)
            val chosen = day == selected
            Column(
                horizontalAlignment = Alignment.CenterHorizontally,
                modifier = Modifier
                    .testTag(WORK_HOURS_DAY_TAG + day)
                    .background(if (chosen) DeepNavy else Color.White, RoundedCornerShape(12.dp))
                    .border(1.dp, DeepNavy.copy(alpha = 0.15f), RoundedCornerShape(12.dp))
                    .clickable { onSelect(day) }
                    .handCursor()
                    .padding(horizontal = 10.dp, vertical = 6.dp)
            ) {
                Text(dayShort(date.dayOfWeek), style = MaterialTheme.typography.labelSmall, color = if (chosen) LightGold else DeepNavy.copy(alpha = 0.7f))
                Text(date.day.toString(), style = MaterialTheme.typography.titleSmall, fontWeight = FontWeight.Bold, color = if (chosen) Color.White else DeepNavy)
                DayMarker(state.summary(day))
            }
        }
    }
}

/** Wide windows: the month's days with their status, beside the chosen day. */
@Composable
private fun DayList(state: WorkHoursUiState, selected: String, onSelect: (String) -> Unit, modifier: Modifier = Modifier) {
    val listState = rememberLazyListState()
    LaunchedEffect(state.days.size) {
        val index = state.days.indexOf(selected)
        if (index > 0) listState.scrollToItem((index - 3).coerceAtLeast(0))
    }
    LazyColumn(state = listState, modifier = modifier.padding(start = 16.dp, top = 8.dp, bottom = 8.dp), verticalArrangement = Arrangement.spacedBy(6.dp)) {
        item("title") {
            Text(stringResource(Res.string.work_hours_days), style = MaterialTheme.typography.titleSmall, fontWeight = FontWeight.Bold, color = DeepNavy.copy(alpha = 0.7f))
        }
        items(state.days, key = { it }) { day ->
            val chosen = day == selected
            val summary = state.summary(day)
            Row(
                verticalAlignment = Alignment.CenterVertically,
                modifier = Modifier
                    .fillMaxWidth()
                    .testTag(WORK_HOURS_DAY_TAG + day)
                    .background(if (chosen) DeepNavy else Color.White, RoundedCornerShape(12.dp))
                    .clickable { onSelect(day) }
                    .handCursor()
                    .padding(horizontal = 12.dp, vertical = 10.dp)
            ) {
                Column(Modifier.weight(1f)) {
                    Text(
                        dayAndDate(LocalDate.parse(day)), style = MaterialTheme.typography.bodyMedium, fontWeight = FontWeight.SemiBold,
                        color = if (chosen) Color.White else DeepNavy, maxLines = 1, overflow = TextOverflow.Ellipsis
                    )
                    val asking = state.askingWhoWorked(day).size
                    if (summary != null && (summary.shifts > 0 || asking > 0) && day <= (state.today ?: day)) DayStatus(summary, asking)
                }
                DayMarker(summary)
            }
        }
    }
}

/** The chosen day: its clock-ins to decide, open shifts asking who worked, each shift's row and "Potwierdź dzień". */
@Composable
private fun DayContent(
    state: WorkHoursUiState,
    date: String,
    viewModel: WorkHoursViewModel,
    clockReview: @Composable (date: String) -> Unit
) {
    val rows = state.rows(date)
    val mayEdit = state.mayEdit(date)
    var editing by remember { mutableStateOf<String?>(null) }
    var actualWorkOf by remember { mutableStateOf<String?>(null) }
    var splitOf by remember { mutableStateOf<String?>(null) }
    Column(
        Modifier.fillMaxWidth().background(DeepNavy, RoundedCornerShape(16.dp)).padding(16.dp),
        verticalArrangement = Arrangement.spacedBy(12.dp)
    ) {
        Text(stringResource(Res.string.work_hours_note), style = MaterialTheme.typography.bodySmall, color = Color.White.copy(alpha = 0.7f))
        if (date in state.lockedDays) {
            Row(verticalAlignment = Alignment.CenterVertically) {
                Icon(Icons.Default.Lock, contentDescription = null, tint = LightGold, modifier = Modifier.size(18.dp))
                Spacer(Modifier.width(8.dp))
                Text(stringResource(Res.string.work_hours_locked), style = MaterialTheme.typography.bodyMedium, color = LightGold)
            }
        }
        // SH-134: unplanned clock-ins and flags are decided in their own list first.
        if (mayEdit) clockReview(date)
        // SH-128: open shifts of the day nobody said who worked.
        if (mayEdit) WhoWorkedSection(state.askingWhoWorked(date), state.staff, viewModel::recordWorker, nobodyWorked = state.nobodyWorked(date))
        if (rows.isEmpty()) {
            Text(stringResource(Res.string.work_hours_day_no_shifts), style = MaterialTheme.typography.bodyMedium, color = Color.White.copy(alpha = 0.7f))
        }
        rows.forEach { row ->
            WorkHoursRowView(
                row = row,
                state = state,
                mayEdit = mayEdit && row.shiftId !in state.busy,
                onAsPlanned = { viewModel.asPlanned(row.shiftId) },
                onAsClocked = { viewModel.asClocked(row.shiftId) },
                onEdit = { editing = row.shiftId },
                onActualWork = { actualWorkOf = row.shiftId }.takeIf { state.actualWorkOffered },
                onSplit = { splitOf = row.shiftId }.takeIf { state.actualWorkOffered && row.shift.split == null && row.shift.workerId != null },
                onUndoSplit = { viewModel.undoSplit(row.shiftId) }.takeIf { state.actualWorkOffered && row.shift.split != null }
            )
        }
        val waiting = rows.count { (it.status == WorkHoursStatus.TO_CONFIRM || it.status == WorkHoursStatus.REPORTED) && it.shiftId !in state.busy }
        if (mayEdit && waiting > 0) {
            Button(
                onClick = viewModel::confirmDay,
                modifier = Modifier.fillMaxWidth().handCursor().testTag(WORK_HOURS_CONFIRM_DAY_TAG),
                colors = ButtonDefaults.buttonColors(containerColor = LightGold, contentColor = DeepNavy)
            ) {
                Icon(Icons.Default.DoneAll, contentDescription = null, modifier = Modifier.size(18.dp))
                Spacer(Modifier.width(8.dp))
                Text(stringResource(Res.string.work_hours_confirm_day), fontWeight = FontWeight.Bold)
            }
            Text(stringResource(Res.string.work_hours_confirm_day_hint), style = MaterialTheme.typography.bodySmall, color = Color.White.copy(alpha = 0.7f))
        }
    }
    rows.firstOrNull { it.shiftId == editing }?.let { row ->
        EditHoursDialog(row, onDismiss = { editing = null }, onSave = { times ->
            editing = null
            viewModel.editTimes(row.shiftId, times)
        })
    }
    rows.firstOrNull { it.shiftId == actualWorkOf }?.let { row ->
        ActualWorkDialog(
            shift = row.shift,
            staff = state.staff,
            nameOf = state::nameOf,
            onDismiss = { actualWorkOf = null },
            onSave = { worker, actual, absence ->
                actualWorkOf = null
                viewModel.recordActualWork(row.shiftId, worker, actual, absence)
            }
        )
    }
    rows.firstOrNull { it.shiftId == splitOf }?.let { row ->
        SplitShiftDialog(
            shift = row.shift,
            staff = state.staff,
            nameOf = state::nameOf,
            today = state.today,
            onDismiss = { splitOf = null },
            onSplit = { request ->
                splitOf = null
                viewModel.splitShift(row.shiftId, request)
            }
        )
    }
}

private fun span(range: TimeRange): String =
    "${range.start.substringAfter('T').take(5)}–${range.end.substringAfter('T').take(5).ifEmpty { "…" }}"

@OptIn(ExperimentalLayoutApi::class)
@Composable
private fun WorkHoursRowView(
    row: WorkHoursRow,
    state: WorkHoursUiState,
    mayEdit: Boolean,
    onAsPlanned: () -> Unit,
    onAsClocked: () -> Unit,
    onEdit: () -> Unit,
    onActualWork: (() -> Unit)?,
    onSplit: (() -> Unit)?,
    onUndoSplit: (() -> Unit)?
) {
    val shape = RoundedCornerShape(14.dp)
    val waiting = row.status.needsManager
    val confirmed = row.status == WorkHoursStatus.CONFIRMED
    val muted = Color.White.copy(alpha = 0.75f)
    // SH-262: a confirmed shift reads as done at a glance (green, its buttons behind "Zmień"); one
    // waiting for the manager stands out (a thick gold frame).
    var reopened by remember(row.shiftId) { mutableStateOf(false) }
    Column(
        Modifier
            .fillMaxWidth()
            .testTag(WORK_HOURS_ROW_TAG + row.shiftId)
            .background(
                when {
                    confirmed -> ConfirmedOnNavy.copy(alpha = 0.12f)
                    waiting -> LightGold.copy(alpha = 0.10f)
                    else -> Color.White.copy(alpha = 0.04f)
                },
                shape
            )
            .border(
                if (waiting) 2.dp else 1.dp,
                when {
                    confirmed -> ConfirmedOnNavy.copy(alpha = 0.55f)
                    waiting -> LightGold
                    else -> Color.White.copy(alpha = 0.15f)
                },
                shape
            )
            .padding(12.dp),
        verticalArrangement = Arrangement.spacedBy(4.dp)
    ) {
        Row(verticalAlignment = Alignment.CenterVertically) {
            Text(
                personName(row.workerName), style = MaterialTheme.typography.titleSmall, fontWeight = FontWeight.Bold, color = Color.White,
                modifier = Modifier.weight(1f), maxLines = 1, overflow = TextOverflow.Ellipsis
            )
            StatusChip(row)
        }
        Text(stringResource(Res.string.work_hours_plan, span(row.planned)), style = MaterialTheme.typography.bodySmall, color = muted)
        val clocked = row.clocked
        when {
            row.status == WorkHoursStatus.CONFIRMED && clocked != null ->
                Text(stringResource(Res.string.work_hours_actual, span(clocked)), style = MaterialTheme.typography.bodyMedium, fontWeight = FontWeight.SemiBold, color = Color.White)
            clocked != null && row.shift.clockAudit?.reportedByWorker == true ->
                Text(stringResource(Res.string.work_hours_reported, span(clocked)), style = MaterialTheme.typography.bodyMedium, color = LightGold)
            clocked != null ->
                Text(stringResource(Res.string.work_hours_clocked, span(clocked)), style = MaterialTheme.typography.bodyMedium, color = Color.White)
            row.status != WorkHoursStatus.NOT_WORKED ->
                Text(stringResource(Res.string.work_hours_not_clocked), style = MaterialTheme.typography.bodySmall, color = muted)
        }
        // SH-134: what is unusual about the clocked times.
        if (row.flags.isNotEmpty()) {
            FlowRow(horizontalArrangement = Arrangement.spacedBy(6.dp), verticalArrangement = Arrangement.spacedBy(4.dp)) {
                row.flags.forEach { flag ->
                    Text(
                        stringResource(clockFlagLabel(flag)),
                        style = MaterialTheme.typography.labelSmall, color = DeepNavy,
                        modifier = Modifier.background(LightGold, RoundedCornerShape(8.dp)).padding(horizontal = 8.dp, vertical = 2.dp)
                    )
                }
            }
        }
        // SH-236: who worked it when not as planned, and a split part's handover.
        ActualWorkLines(row.shift, state::nameOf, color = muted)
        // Today's shifts not over yet: only who worked them (SH-236); the hours wait until the end.
        val actionable = mayEdit && row.status != WorkHoursStatus.TO_DECIDE
        if (actionable && confirmed && !reopened) {
            RowAction(stringResource(Res.string.work_hours_change), Icons.Default.Edit, WORK_HOURS_CHANGE_TAG + row.shiftId) { reopened = true }
        } else if (actionable) {
            FlowRow(horizontalArrangement = Arrangement.spacedBy(6.dp), verticalArrangement = Arrangement.spacedBy(2.dp)) {
                if (row.status != WorkHoursStatus.NOT_WORKED && row.status != WorkHoursStatus.NOT_YET) {
                    if (row.hasPlan) RowAction(stringResource(Res.string.work_hours_as_planned), Icons.Default.EventNote, WORK_HOURS_AS_PLANNED_TAG + row.shiftId, onAsPlanned)
                    if (row.hasFullTimes && row.status != WorkHoursStatus.CONFIRMED) {
                        val label = if (row.status == WorkHoursStatus.REPORTED) Res.string.work_hours_confirm_reported else Res.string.work_hours_as_clocked
                        RowAction(stringResource(label), Icons.Default.CheckCircle, WORK_HOURS_AS_CLOCKED_TAG + row.shiftId, onAsClocked)
                    }
                    RowAction(stringResource(Res.string.work_hours_edit), Icons.Default.Edit, WORK_HOURS_EDIT_TAG + row.shiftId, onEdit)
                }
                if (onActualWork != null) MoreActions(row.shiftId, onActualWork, onSplit, onUndoSplit)
            }
        }
    }
}

/** SH-262: a badge: green with a tick when confirmed, filled gold when the manager has to act. */
@Composable
private fun StatusChip(row: WorkHoursRow) {
    val (text, color) = when (row.status) {
        WorkHoursStatus.CONFIRMED -> Res.string.work_hours_status_confirmed to ConfirmedOnNavy
        WorkHoursStatus.TO_CONFIRM -> Res.string.work_hours_status_to_confirm to LightGold
        WorkHoursStatus.REPORTED -> Res.string.work_hours_status_reported to LightGold
        WorkHoursStatus.TO_DECIDE -> Res.string.work_hours_status_to_decide to LightGold
        WorkHoursStatus.NOT_WORKED -> Res.string.work_hours_status_not_worked to Color.White.copy(alpha = 0.7f)
        WorkHoursStatus.NOT_YET -> Res.string.work_hours_status_not_yet to Color.White.copy(alpha = 0.7f)
    }
    val confirmed = row.status == WorkHoursStatus.CONFIRMED
    val filled = row.status.needsManager
    Row(
        verticalAlignment = Alignment.CenterVertically,
        modifier = Modifier
            .background(if (filled) color else color.copy(alpha = 0.16f), RoundedCornerShape(50))
            .padding(horizontal = 10.dp, vertical = 3.dp)
    ) {
        if (confirmed) {
            Icon(Icons.Default.CheckCircle, contentDescription = null, tint = color, modifier = Modifier.size(14.dp))
            Spacer(Modifier.width(4.dp))
        }
        Text(
            stringResource(text), style = MaterialTheme.typography.labelMedium, fontWeight = FontWeight.SemiBold,
            color = if (filled) DeepNavy else color,
            modifier = Modifier.testTag(WORK_HOURS_STATUS_TAG + row.shiftId)
        )
    }
}

@Composable
private fun RowAction(label: String, icon: androidx.compose.ui.graphics.vector.ImageVector, tag: String, onClick: () -> Unit) {
    TextButton(
        onClick = onClick,
        colors = ButtonDefaults.textButtonColors(contentColor = LightGold),
        modifier = Modifier.handCursor().testTag(tag)
    ) {
        Icon(icon, contentDescription = null, modifier = Modifier.size(18.dp))
        Spacer(Modifier.width(6.dp))
        Text(label)
    }
}

/** "Nie przyszedł · Zastępstwo · Podział": the SH-236 dialogs (who worked, split the shift, undo a split). */
@Composable
private fun MoreActions(shiftId: String, onActualWork: () -> Unit, onSplit: (() -> Unit)?, onUndoSplit: (() -> Unit)?) {
    var open by remember { mutableStateOf(false) }
    Box {
        OutlinedButton(
            onClick = { open = true },
            colors = ButtonDefaults.outlinedButtonColors(contentColor = LightGold),
            border = BorderStroke(1.dp, LightGold.copy(alpha = 0.6f)),
            modifier = Modifier.handCursor().testTag(WORK_HOURS_MORE_TAG + shiftId)
        ) {
            Icon(Icons.Default.MoreHoriz, contentDescription = null, modifier = Modifier.size(18.dp))
            Spacer(Modifier.width(6.dp))
            Text(stringResource(Res.string.work_hours_who_worked))
        }
        DropdownMenu(expanded = open, onDismissRequest = { open = false }) {
            DropdownMenuItem(
                text = { Text(stringResource(Res.string.actual_work_action)) },
                leadingIcon = { Icon(Icons.Default.HowToReg, contentDescription = null) },
                onClick = { open = false; onActualWork() },
                modifier = Modifier.handCursor().testTag(com.evoapps.evoshift.ui.roster.ACTUAL_WORK_ACTION_TAG + shiftId)
            )
            onSplit?.let { split ->
                DropdownMenuItem(
                    text = { Text(stringResource(Res.string.split_action)) },
                    leadingIcon = { Icon(Icons.AutoMirrored.Filled.CallSplit, contentDescription = null) },
                    onClick = { open = false; split() },
                    modifier = Modifier.handCursor().testTag(com.evoapps.evoshift.ui.roster.SPLIT_ACTION_TAG + shiftId)
                )
            }
            onUndoSplit?.let { undo ->
                DropdownMenuItem(
                    text = { Text(stringResource(Res.string.split_undo)) },
                    leadingIcon = { Icon(Icons.AutoMirrored.Filled.Undo, contentDescription = null) },
                    onClick = { open = false; undo() },
                    modifier = Modifier.handCursor().testTag(com.evoapps.evoshift.ui.roster.SPLIT_UNDO_TAG + shiftId)
                )
            }
        }
    }
}

/** "Edytuj": the shift's start and end (an end at or before the start is the next day). */
@Composable
private fun EditHoursDialog(row: WorkHoursRow, onDismiss: () -> Unit, onSave: (TimeRange) -> Unit) {
    val source = row.clocked?.takeIf { it.end.isNotEmpty() } ?: row.planned
    var start by rememberSaveable(row.shiftId) { mutableStateOf(source.start.substringAfter('T').take(5)) }
    var end by rememberSaveable(row.shiftId) { mutableStateOf(source.end.substringAfter('T').take(5)) }
    var showErrors by remember { mutableStateOf(false) }
    val date = remember(row.shift.date) { runCatching { LocalDate.parse(row.shift.date) }.getOrNull() }
    val startClock = parseClockTime(start)
    val endClock = parseClockTime(end)
    val times = if (date != null && startClock != null && endClock != null && startClock != endClock) {
        runCatching { plannedTimeRange(date, startClock, endClock) }.getOrNull()
    } else null
    EvoDialog(
        title = stringResource(Res.string.work_hours_edit_title, personName(row.workerName)),
        subtitle = stringResource(Res.string.work_hours_edit_planned, span(row.planned)),
        icon = Icons.Default.Schedule,
        onDismiss = onDismiss,
        confirm = DialogAction(
            stringResource(Res.string.save),
            {
                showErrors = true
                times?.let(onSave)
            },
            enabled = times != null || !showErrors
        )
    ) {
        Row(horizontalArrangement = Arrangement.spacedBy(12.dp), verticalAlignment = Alignment.Top) {
            EvoTimeField(start, { start = it }, stringResource(Res.string.actual_work_start), Modifier.weight(1f).testTag(WORK_HOURS_EDIT_START_TAG), showErrors = showErrors)
            EvoTimeField(end, { end = it }, stringResource(Res.string.actual_work_end), Modifier.weight(1f).testTag(WORK_HOURS_EDIT_END_TAG), showErrors = showErrors)
        }
        if (showErrors && times == null) {
            Text(stringResource(Res.string.clock_review_edit_invalid), color = MaterialTheme.colorScheme.error, style = MaterialTheme.typography.bodySmall)
        }
    }
}

/**
 * SH-257: the daily results' one line about the day's hours ("Godziny: 5 zmian, 2 do potwierdzenia →"),
 * opening Godziny pracy on that day ([onOpen]); the hours are confirmed there.
 */
@Composable
internal fun DayHoursLine(summary: WorkHoursDaySummary, onOpen: () -> Unit, modifier: Modifier = Modifier) {
    val shifts = org.jetbrains.compose.resources.pluralStringResource(Res.plurals.daily_hours_shifts, summary.shifts, summary.shifts)
    val text = when {
        summary.shifts == 0 -> stringResource(Res.string.daily_hours_line_none)
        summary.toConfirm > 0 -> stringResource(Res.string.daily_hours_line, shifts, summary.toConfirm)
        summary.confirmed -> stringResource(Res.string.daily_hours_line_confirmed, shifts)
        else -> stringResource(Res.string.daily_hours_line_plain, shifts)
    }
    val description = stringResource(Res.string.work_hours_open)
    TextButton(
        onClick = onOpen,
        colors = ButtonDefaults.textButtonColors(contentColor = if (summary.toConfirm > 0) LightGold else Color.White),
        contentPadding = PaddingValues(horizontal = 0.dp, vertical = 4.dp),
        modifier = modifier.fillMaxWidth().handCursor().testTag(DAILY_HOURS_LINE_TAG).semantics { contentDescription = description }
    ) {
        Icon(Icons.Default.Timer, contentDescription = null, modifier = Modifier.size(18.dp))
        Spacer(Modifier.width(8.dp))
        Text(text, modifier = Modifier.weight(1f), fontWeight = FontWeight.SemiBold)
        Icon(Icons.AutoMirrored.Filled.KeyboardArrowRight, contentDescription = null, modifier = Modifier.size(20.dp))
    }
}

/** Test tag of the daily results' hours line. */
const val DAILY_HOURS_LINE_TAG = "daily_hours_line"
